import { jsx as n } from "react/jsx-runtime";
import { c as s, a as e } from "../../vendor-BBkOA5CU.js";
import { getButtonStyles as c } from "../BaseButton/index.js";
import '../../assets/index3.css';const a = "ecwbsq_skipToContent", r = {
  skipToContent: a
}, f = ({ targetId: t = "main-content" }) => {
  const o = s(c({ variant: "secondary" }), r.skipToContent);
  return /* @__PURE__ */ n(e, { href: `#${t}`, className: o, target: "_self", children: "Skip to main content" });
};
export {
  f as SkipToContent
};
//# sourceMappingURL=index.js.map
